export interface ShopCollection {
  id: string
  number: string
  eyebrow: string
  name: string
  description: string
  status: 'coming-soon' | 'available'
  relationship?: 'direct' | 'affiliate'
  price?: string
  url?: string
}

export const shopCollections: ShopCollection[] = [
  {
    id: 'field-tools',
    number: '01',
    eyebrow: 'OMIKINA OBJECTS',
    name: 'Field tools',
    description: 'Purposeful notebooks, reference cards, and desk tools for tracing systems and checking claims.',
    status: 'coming-soon',
  },
  {
    id: 'reading-list',
    number: '02',
    eyebrow: 'CURATED AFFILIATE LINKS',
    name: 'The reading shelf',
    description: 'Books and research tools selected for usefulness, with every commission-bearing link labeled before the click.',
    status: 'coming-soon',
  },
  {
    id: 'infrastructure-objects',
    number: '03',
    eyebrow: 'LIMITED DROPS',
    name: 'The machine, made tangible',
    description: 'Small-batch objects inspired by compute, power, networks, and the physical infrastructure behind AI.',
    status: 'coming-soon',
  },
]
